export default class BootstrapOverrides {
    constructor() {


        var tabs = document.querySelectorAll('#information .nav-link');
        var tabContent = document.querySelectorAll('#information .tab-pane');

        if (window.innerWidth < 768) {


            for (var i = 0; i < tabContent.length; i++) {
                var elem = tabContent[i];
                elem.classList.remove("active", "show", "fade");
                elem.classList.add("offcanvas", "offcanvas-end", "offcanvas-body");
            };


            for (var i = 0; i < tabs.length; i++) {
                var elem = tabs[i];
                elem.classList.remove("active");
                elem.setAttribute("data-bs-toggle", "offcanvas");
            };
        }
    }
}